import { lazy, Suspense, useEffect } from 'react';
import { useDelayedReveal } from './hooks/useDelayedReveal';
import { S01Hero } from './components/sections/S01Hero';
import { S15Footer } from './components/sections/S15Footer';

// Code-split: las secciones 02-14 no son visibles al cargar (delay 930s),
// así que su JS no debe pesar en la carga inicial.
const DelayedSections = lazy(() =>
  import('./components/sections/DelayedSections').then(m => ({ default: m.DelayedSections }))
);

function App() {
  // Captura de UTMs — PROJECT-REALCHANGE.md §6.2 (código literal del spec)
  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    const utmKeys = ['utm_source', 'utm_medium', 'utm_campaign', 'utm_content', 'utm_term'];

    utmKeys.forEach(key => {
      const value = params.get(key);
      if (value) localStorage.setItem(key, value);
    });

    if (!localStorage.getItem('landing_page_initial')) {
      const initialLanding = window.location.pathname || '/';
      localStorage.setItem('landing_page_initial', initialLanding);
      localStorage.setItem('landing_page_timestamp', new Date().toISOString());
    }
  }, []);

  const unlocked = useDelayedReveal();

  return (
    <main>
      <S01Hero />
      {unlocked && (
        <Suspense fallback={null}>
          <DelayedSections />
        </Suspense>
      )}
      <S15Footer />
    </main>
  );
}

export default App;
